import { graphemeLength, segmentGraphemes } from "@/lib/graphemes";

/**
 * Reverses text one user-perceived character (grapheme cluster) at a time, so a flag
 * (two regional indicators), a skin-tone emoji, a ZWJ family, a letter with a combining
 * accent and a CRLF line break each stay whole. The text is NFC-normalized first, as
 * `segmentGraphemes` does, so an e plus combining acute comes out as a single é.
 */
export function reverseGraphemes(text: string): string {
  return segmentGraphemes(text).reverse().join("");
}

/** The number of user-perceived characters, which is what a reader counts. */
export function countGraphemes(text: string): number {
  return graphemeLength(text);
}
